module.exports = __webpack_public_path__ + "img/ball-pile.9b6fcff2.svg";